// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2TzA9","overflowing":"ReadFullNote_overflowing__3OMOZ"};